import { emperor } from '~/services';

export type ActivationCheckStatus = 'ok' | 'warn' | 'fail';

export interface ActivationCheck {
  key: string;
  label: string;
  status: ActivationCheckStatus;
  detail: string;
}

export interface ActivationChecksResponse {
  verdict: 'ready' | 'action_needed';
  checks: ActivationCheck[];
  // Setup steps the server performed during the run (e.g. re-ran the event import).
  actions: string[];
}

export const runHomebodyActivationChecks = async (
  buildingId: string
): Promise<{ data: ActivationChecksResponse }> => {
  return await emperor.post(
    `/external-partner/building/${buildingId}/activation-checks`
  );
};
